module.exports = __webpack_public_path__ + "img/maxiel.159c83f2.jpg";